import { DeviceService } from "@/common/api.service";
import { FETCH_DEVICE_DATA, ADD_DEVICE_DATA, DELETE_DEVICE_DATA, RESET_STATE } from "./actions.type";
import { SET_DEVICE_DATA, SET_DEVICE_ERROR, STATE_RESET } from "./mutations.type";

const initialState = () => {
    return {
        devicedata: [],
        deviceerror: [],
    }
};

export const state = initialState()

const actions = {

    async [FETCH_DEVICE_DATA](context, slug) {
        return await DeviceService.get(slug.params.patientId).then(response => {
            context.commit(SET_DEVICE_DATA, response.data)
            return response
        }).catch(({ response }) => {
            context.commit(SET_DEVICE_ERROR, response.errorMessage)
            return response
        })
    },

    async [ADD_DEVICE_DATA](context, slug) {
        return await DeviceService.create(slug.params.patientId + '/' + slug.params.deviceId, slug.params).then((response) => {
            return response
        }).catch(({ response }) => {
            context.commit(SET_DEVICE_ERROR, response.data.errorMessage)
            return response
        })
    },

    async [DELETE_DEVICE_DATA](context, slug) {
        return await DeviceService.destroy(slug.params.patientId + '/' + slug.params.deviceId, slug.params).then((response) => {
            return response
        }).catch(({ response }) => {
            context.commit(SET_DEVICE_ERROR, response.data.errorMessage)
            return response
        })
    },

    [RESET_STATE]({ commit }) {
        commit(STATE_RESET)
    }

}

const mutations = {

    [SET_DEVICE_DATA](state, devicedata) {
        state.devicedata = devicedata
    },
    [SET_DEVICE_ERROR](state, error) {
        state.deviceerror = error
    },
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    }

}

const getters = {

    devicedata(state) {
        return state.devicedata;
    },

}

export default {
    state,
    getters,
    actions,
    mutations
};